import { Theme, css } from '@emotion/react';

export const dateSection = ({ spacing }: Theme) => css`
  padding: ${spacing(2.5)}px ${spacing(2.5)}px 0 ${spacing(2.5)}px;
`;

export const select = ({ spacing }: Theme) => css`
  margin-top: ${spacing(1)}px;
  padding: ${spacing(1.5)}px ${spacing(2.5)}px 0;
`;

export const dialogContent = ({ spacing }: Theme) => css`
  padding: 0 0 ${spacing(2.5)}px;
`;
